import request from '@/shared/api/request';

export const deleteDatabase = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'DELETE',
  });
